<alaris-dialog [closeAction]="close.bind(this)" size="xl" class="modal-container" [confirmButtonText]="''">
	<div slot="content">
		<div class="logs">
			@for (log of logs; track $index) {
				<h4>{{'history_logs.action_id' | translate}}&nbsp;{{log.ActionID}}</h4>
				<div>
					<hr class="divider">
					<div class="log">
						<div class="entity old">
							<div class="label">{{'history_logs.before' | translate}}</div>
							@if (!isEmpty(log.EntityOld)) {
								@for (item of getStyledEntity(log.EntityOld, []); track item) {
								<span>
									<strong>{{ item.key }}:</strong> {{ item.value }}
								</span>
								}
							}
						</div>
						<div class="entity new">
							<div class="label">{{'history_logs.after' | translate}}</div>
							@if (!isEmpty(log.EntityNew)) {
								@for (item of getStyledEntity(log.EntityNew, getDifferences(log.EntityOld, log.EntityNew)); track item) {
									<span [ngClass]="{ 'highlight ': !!item.highlight }">
										<strong>{{ item.key }}:</strong> <span>{{ item.value }}</span>
									</span>
								}
							}
						</div>
					</div>
				</div>
			}
		</div>
	</div>
</alaris-dialog>
